module.exports = __webpack_public_path__ + "media/patrimonio-animation-es.16b1c9b7.mp4";